const googleDriveDirectDownloadLink = (link, docId) => {
  let docType = "file";
  let finalLink = "";

  if (link.startsWith("https://docs.google.com/presentation")) {
    docType = "presentation";
    finalLink =
      "https://docs.google.com/presentation/d/" + docId + "/export/pptx";
  } else if (link.startsWith("https://docs.google.com/document")) {
    docType = "document";
    finalLink =
      "https://docs.google.com/document/d/" + docId + "/export?format=docx";
  } else if (link.startsWith("https://docs.google.com/spreadsheets")) {
    docType = "document";
    finalLink =
      "https://docs.google.com/spreadsheets/d/" + docId + "/export?format=xlsx";
  } else if (docType === "file") {
    finalLink = "https://drive.google.com/uc?export=download&id=" + docId;
  } else {
    return false;
  }

  return finalLink;
};

const imgurDirectDownloadLink = link => {
  const idExtractor = /imgur.com\/(.*)/;
  const result = idExtractor.exec(link);
  const imgId = result[1];

  if (!imgId) {
    false;
  }

  return "https://imgur.com/download/" + imgId;
};

export default {
  directDownloadLink(link) {
    const idExtractor = /\/d\/(.+?)(?:\/|#|\?|$)/;
    const result = idExtractor.exec(link);

    if (result) {
      const docId = result[1];
      return googleDriveDirectDownloadLink(link, docId);
    } else if (link.includes("imgur.com")) {
      return imgurDirectDownloadLink(link);
    }

    return false;
  }
};
